module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-orange-bd4190e659865321182fd6be453345d0.svg";